
export const rem = (pixel) => {
    const divisor = parseInt(getComputedStyle(document.querySelector("html")).fontSize);
    return parseInt(pixel) / divisor + 'rem';
}
